<mat-horizontal-stepper linear="false" #stepper (selectionChange)="changeStepper($event, stepper)">
  <mat-step [completed]="isFirstStepCompleted" [hasError]="firstStepError">
    <ng-template matStepLabel>{{ 'request.matStepLabel1' | translate }}</ng-template>
    <scf-point-of-sale
      [mode]="mode"
      [request]="request"
      [state]="state"
      [isMG]="false"
      [isMgWithShopping]="true"
      (changeContinueStatus)="changeContinueStatusForms($event)"
      (establishment)="setEstablishment($event)"
      (vendor)="setVendor($event)"
      (isFinishedLoading)="changeContinueLoadingStatus($event)"
    >
    </scf-point-of-sale>
    <scf-prescriber-contact-data
      [mode]="mode"
      [request]="request"
      [state]="state"
      (isFinishedLoading)="changeContinueLoadingStatus($event)"
      (changeContinueStatus)="changeContinueStatusForms($event)"
    >
    </scf-prescriber-contact-data>
    <scf-request-data-mg
      [mode]="mode"
      [request]="request"
      [state]="state"
      [establishment]="establishmentToSend"
      [vendor]="vendorToSend"
      (changeContinueStatus)="changeContinueStatusForms($event)"
      (financeEmitter)="sendFinanceData($event)"
      (isFinishedLoading)="changeContinueLoadingStatus($event)"
    >
    </scf-request-data-mg>
    <scf-request-finance-mg
      *ngIf="mode !== 'view'"
      [mode]="mode"
      [state]="state"
      [request]="request"
      [establishment]="establishmentToSend"
      [changing]="changingValueClearTable"
      [financingCallDtoList]="financingDtoToSend"
      (changeContinueStatus)="changeContinueStatusForms($event)"
      (isFinishedLoading)="changeContinueLoadingStatus($event)"
    ></scf-request-finance-mg>
    <scf-request-data-card
      [mode]="mode"
      [request]="request"
      [state]="state"
      (changeContinueStatus)="changeContinueStatusForms($event)"
      (isFinishedLoading)="changeContinueLoadingStatus($event)"
    ></scf-request-data-card>
    <div class="row" class="btnActions">
      <div class="btnLeft">
        <button
          id="clearFieldsButtonFirstStepMG"
          *ngIf="mode !== 'view'"
          mat-stroked-button
          color="accent"
          (click)="clearFields()"
        >
          {{ 'request.buttonReset' | translate | uppercase }}
        </button>
      </div>
      <div class="btnRight">
        <button id="nextStepButtonFirstStepMG" mat-flat-button color="accent" matStepperNext>
          {{ 'request.matStepperNext' | translate | uppercase }}
        </button>
      </div>
    </div>
  </mat-step>

  <mat-step [completed]="isSecondStepCompleted" [hasError]="secondStepError">
    <ng-template matStepLabel>{{ 'request.matStepLabel2' | translate }}</ng-template>
    <scf-holder-data
      [mode]="mode"
      [request]="request"
      [state]="state"
      (changeContinueStatus)="changeContinueStatusForms($event)"
      (isFinishedLoading)="changeContinueLoadingStatus($event)"
    ></scf-holder-data>
    <scf-contact-data
      [mode]="mode"
      [request]="request"
      [state]="state"
      [isAuto]="false"
      [isMG]="true"
      [isMgWithShopping]="true"
      [isConsumption]="false"
      [isMG]="true"
      (changeContinueStatus)="changeContinueStatusForms($event)"
      (isFinishedLoading)="changeContinueLoadingStatus($event)"
    ></scf-contact-data>
    <scf-socioeconomic-data
      [mode]="mode"
      [request]="request"
      [state]="state"
      [isMG]="false"
      [isMgWithShopping]="true"
      [isBP]="false"
      (changeContinueStatus)="changeContinueStatusForms($event)"
      (isFinishedLoading)="changeContinueLoadingStatus($event)"
    >
    </scf-socioeconomic-data>
    <div class="row" class="btnActions">
      <div class="btnLeft">
        <button id="previousStepButtonSecondStepMG" mat-flat-button color="accent" matStepperPrevious>
          {{ 'request.matStepperPrevious' | translate | uppercase }}
        </button>
        <button
          id="clearFieldsButtonSecondStepMG"
          *ngIf="mode !== 'view'"
          mat-stroked-button
          color="accent"
          (click)="clearFields()"
        >
          {{ 'request.buttonReset' | translate | uppercase }}
        </button>
      </div>
      <div class="btnRight">
        <button
          id="saveButtonSecondStepMG"
          *ngIf="mode !== 'view' || (mode === 'view' && state.id === '00')"
          mat-stroked-button
          color="accent"
          (click)="openDialogPassword('save')"
        >
          <mat-icon class="icon-ic_save"></mat-icon> {{ 'request.buttonSave' | translate | uppercase }}
        </button>
        <button id="nextStepButtonSecondStepMG" mat-flat-button color="accent" matStepperNext>
          {{ 'request.matStepperNext' | translate | uppercase }}
        </button>
      </div>
    </div>
  </mat-step>

  <mat-step [completed]="isThirdStepCompleted" [hasError]="thirdStepError">
    <ng-template matStepLabel>{{ 'request.matStepLabel3' | translate }}</ng-template>
    <scf-insurance
      [mode]="mode"
      [insurance]="request?.insurance"
      [state]="state"
      (changeContinueStatus)="changeContinueStatusForms($event)"
      (isFinishedLoading)="changeContinueLoadingStatus($event)"
    ></scf-insurance>
    <scf-direct-debit
      [mode]="mode"
      [request]="request"
      [state]="state"
      (changeContinueStatus)="changeContinueStatusForms($event)"
      (isFinishedLoading)="changeContinueLoadingStatus($event)"
    ></scf-direct-debit>
    <scf-request-observations
      [mode]="mode"
      [observations]="request?.observations"
      [request]="request"
      [state]="state"
      (changeContinueStatus)="changeContinueStatusForms($event)"
      (isFinishedLoading)="changeContinueLoadingStatus($event)"
    ></scf-request-observations>
    <p class="terminos">
      {{ 'request.agreementPersonalData' | translate }}
    </p>
    <div class="row" class="btnActions">
      <div class="btnLeft">
        <button id="previousStepButtonThirdStepMG" mat-flat-button color="accent" matStepperPrevious>
          {{ 'request.matStepperPrevious' | translate | uppercase }}
        </button>
        <button
          id="clearFieldsButtonThirdStepMG"
          *ngIf="mode !== 'view'"
          mat-stroked-button
          color="accent"
          (click)="clearFields()"
        >
          {{ 'request.buttonReset' | translate | uppercase }}
        </button>
      </div>
      <div class="btnRight">
        <button
          id="printContractButtonMG"
          *ngIf="mode !== 'view'"
          mat-stroked-button
          color="accent"
          (click)="openDialogPassword('print')"
        >
          <mat-icon class="icon-ic_print"></mat-icon> {{ 'request.buttonPrintContract' | translate | uppercase }}
        </button>
        <button
          id="saveButtonButtonThirdStepMG"
          *ngIf="mode !== 'view' || (mode === 'view' && state.id === '00')"
          mat-stroked-button
          color="accent"
          (click)="openDialogPassword('save')"
        >
          <mat-icon class="icon-ic_save"></mat-icon> {{ 'request.buttonSave' | translate | uppercase }}
        </button>
        <button
          id="sendButtonButtonMG"
          *ngIf="mode !== 'view' || (mode === 'view' && state.id === '00')"
          mat-flat-button
          color="accent"
          [disabled]="!enviarPeticion"
          (click)="openDialogPassword('send')"
        >
          {{ 'request.buttonSend' | translate | uppercase }} <mat-icon class="icon-ic_send"></mat-icon>
        </button>
      </div>
    </div>
  </mat-step>
  <ng-template matStepperIcon="error">
    <mat-icon class="icon-ic_error_warnning"></mat-icon>
  </ng-template>
</mat-horizontal-stepper>
